import { Membre, Relation } from '../types';

const CONJUGAL = ['conjoint', 'ex_conjoint'];

export function getFocusFamily(
  focusId: number,
  membres: Membre[],
  relations: Relation[],
): { membres: Membre[]; relations: Relation[] } {
  const memberMap = new Map(membres.map(m => [m.id, m]));
  const included = new Set<number>();

  const add = (id: number) => { if (memberMap.has(id)) included.add(id); };

  add(focusId);

  // Conjoint(e)s
  const spouseIds: number[] = [];
  relations.forEach(r => {
    if (CONJUGAL.includes(r.type_relation)) {
      if (r.membre_source === focusId) { add(r.membre_cible); spouseIds.push(r.membre_cible); }
      if (r.membre_cible === focusId) { add(r.membre_source); spouseIds.push(r.membre_source); }
    }
  });

  // Parents directs
  const parentIds: number[] = [];
  relations.forEach(r => {
    if (r.type_relation === 'parent' && r.membre_cible === focusId) {
      add(r.membre_source);
      parentIds.push(r.membre_source);
    }
  });

  // Conjoint(e)s des parents + grands-parents
  parentIds.forEach(pid => {
    relations.forEach(r => {
      if (CONJUGAL.includes(r.type_relation)) {
        if (r.membre_source === pid) add(r.membre_cible);
        if (r.membre_cible === pid) add(r.membre_source);
      }
      if (r.type_relation === 'parent' && r.membre_cible === pid) {
        add(r.membre_source);
      }
    });
  });

  // Enfants directs
  const childIds: number[] = [];
  relations.forEach(r => {
    if (r.type_relation === 'parent' && r.membre_source === focusId) {
      add(r.membre_cible);
      childIds.push(r.membre_cible);
    }
  });
  // Enfants via le/la conjoint(e) aussi
  spouseIds.forEach(sid => {
    relations.forEach(r => {
      if (r.type_relation === 'parent' && r.membre_source === sid) {
        add(r.membre_cible);
        childIds.push(r.membre_cible);
      }
    });
  });

  // Conjoint(e)s des enfants + petits-enfants
  const uniqueChildIds = Array.from(new Set(childIds));
  uniqueChildIds.forEach(cid => {
    relations.forEach(r => {
      if (CONJUGAL.includes(r.type_relation)) {
        if (r.membre_source === cid) add(r.membre_cible);
        if (r.membre_cible === cid) add(r.membre_source);
      }
      if (r.type_relation === 'parent' && r.membre_source === cid) {
        add(r.membre_cible);
      }
    });
  });

  // Frères et sœurs (enfants des mêmes parents)
  parentIds.forEach(pid => {
    relations.forEach(r => {
      if (r.type_relation === 'parent' && r.membre_source === pid) {
        add(r.membre_cible);
      }
    });
  });

  const filteredMembers = membres.filter(m => included.has(m.id));
  const filteredRelations = relations.filter(
    r => included.has(r.membre_source) && included.has(r.membre_cible)
  );

  return { membres: filteredMembers, relations: filteredRelations };
}
